<div class="camera-overlay" #overlay>
    <video #video class="camera-video" autoplay playsinline muted></video>

    @if (error$$(); as err) {
        <div class="camera-error">{{ err }}</div>
    }

    <div class="camera-controls">
        <app-button-action (btnClick)="emit_cancel()" [tooltip]="'cancel'">
            <app-icon name="xmark" />
        </app-button-action>

        <app-button-action class="capture" (btnClick)="emit_capture()" [disabled]="!ready$$() || busy$$()" [tooltip]="'foto maken'">
            <app-icon name="camera" />
        </app-button-action>

        <app-button-action (btnClick)="emit_switchCamera()" [disabled]="busy$$()" [tooltip]="'wissel camera'">
            <app-icon name="synchronise" />
        </app-button-action>
    </div>
</div>
